import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Collage, CollageItem } from 'page/ProfileScreen/BasicSelfiesPanel/Collage'
import { store } from 'store/store'
import css from './TypeStep.module.scss'

const fullbody1_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-fullbody-1-d2c5.jpg'
const fullbody2_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-fullbody-2-97a4.jpg'
const fullbody3_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-fullbody-3-dbd5.jpg'
const selfie1_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-selfie-1-364d.jpg'
const selfie2_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-selfie-2-ccb2.jpg'
const selfie3_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/basic-type-selfie-3-6bb3.jpg'

const selfie_images: [CollageItem, CollageItem, CollageItem] = [
  { src: selfie1_jpg, size: 'small' },
  { src: selfie2_jpg, size: 'large' },
  { src: selfie3_jpg, size: 'tiny' },
]

const fullbody_images: [CollageItem, CollageItem, CollageItem] = [
  { src: fullbody1_jpg, size: 'small' },
  { src: fullbody2_jpg, size: 'large' },
  { src: fullbody3_jpg, size: 'tiny' },
]

type CardProps = {
  images: [CollageItem, CollageItem, CollageItem]
  title: string
  hint: string
  action: () => void
}

const Card = observer(({ images, title, hint, action }: CardProps) => {
  return (
    <Vertical className={css.card}>
      <Collage items={images} />
      <Vertical gap={16} wide>
        <Button large primary wide action={action}>
          {title}
        </Button>
        <Typo size={20} secondary center balance>
          {hint}
        </Typo>
      </Vertical>
    </Vertical>
  )
})

export const TypeStep = observer(() => {
  const onSelfie = useLatestCallback(() => {
    store.profile.type = 'selfie'
    store.profile.basic.step = 'first'
  })

  const onFull = useLatestCallback(() => {
    store.profile.type = 'full'
    store.profile.basic.step = 'fullbody'
  })

  return (
    <Vertical gap={40}>
      <Typo size={32} medium upper center>
        {i18n('HowDoYouWantToCreateLook')}
      </Typo>
      <Card
        images={selfie_images}
        title={i18n('TakeSelfie')}
        hint={i18n('TakeSelfieOnPanelAndStartTryOn')}
        action={onSelfie}
      />
      <Card
        images={fullbody_images}
        title={i18n('UploadFullbodyPhoto')}
        hint={i18n('UploadFullbodyPhotoFromPhoneViaQr')}
        action={onFull}
      />
    </Vertical>
  )
})
